import React from "react";
import App from "../components/3D/App";
import About from "../components/about/about";
import Experience from "../components/experience/experience";
import Skills from "../components/skills/skills";
import Contact from "../components/contact/contact";
import Layout from "../components/layout";

const IndexPage = () => {
  return (
    <>
      <React.StrictMode>
        <App />
      </React.StrictMode>
      <About />
      <Experience />
      <Skills />
      <Contact />
    </>
  );
};

IndexPage.Layout = Layout;

export default IndexPage;
